import { Fragment, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { orderActions } from "../../../../../store/orders-slice"
import { faArrowDownAZ } from "@fortawesome/free-solid-svg-icons"
import useFilter from "../../../../../hook/useFilter"
import useVariable from "../../../../../hook/useVariable"
import Resort from "./resort"
import { useDispatch, useSelector } from "react-redux"
import Pagination from "./pagination"
import InfoIcon from "../../../../InfoIcon"

export default function Filter({children}){


    const [showFilter, setShowFilter] = useState(false)

    let defaultordercount = useSelector((state) => state.order.filterOrderCount)
    let pagination = useSelector((state) => state.order.pagination)
    let sliceFilters = useSelector(state => state.order.filter)
    let sliceActions = orderActions
    let sliceItems = useSelector(state => state.order.orders)

     const { doFilter } = useFilter()
        const { variableValue } = useVariable()

        const [paginationItems, setPaginationItems] = useState([])

        let dispatch=useDispatch()

        const [isMount, setIsMount] = useState(false)



        useEffect(() => {
            let items = []
            if (pagination) {
                pagination.map((item, key) => {
    
                    items.push(<Pagination key={key} orders={item} index={key} />)
                })
            }
    
            setPaginationItems(items)
        }, [pagination])



            useEffect(() => {
        
                if (!isMount) {
                    setIsMount(true)
                    return
                }
        
        
                doFilter(sliceFilters, sliceItems, sliceActions)
            }, [sliceFilters])



    return <div className="p-3" >
       
        <div className="card shadow  bg-white rounded p-3 mb-3" style={{ cursor: 'pointer' }} onClick={() => {
            setShowFilter(!showFilter)
        }}  >

            <InfoIcon icon={faArrowDownAZ} size='xl' />

        </div>
        {showFilter &&
            <Fragment>
                <label>Pagination</label><select name="filterPostCount" defaultValue={sliceFilters.pagination} className="mb-2" onChange={(event) => {
                    let value = variableValue(event.target.value)
                    dispatch(orderActions.setFilter({
                        key: 'pagination',
                        value
                    }))

                }} >
                    <option value='' >All</option>

                    {
                        defaultordercount.map((item, key) => {

                            return <option key={key} value={item} >{item}</option>
                        })
                    }
                </select>

                <Resort type='order_id' name='OrderId' />
                <Resort type='product_title' name='ProductTitle' />
                <Resort type='active' name='Active' />
                <Resort type='start' name='Start' />
                <Resort type='end' name='End' />
                
            </Fragment>}
        <input type="text" name="filter-email-username" className="mb-2" defaultValue={sliceFilters.search} placeholder="order id or product title" onInput={(event) => {
            let value = variableValue(event.target.value)

            dispatch(orderActions.setFilter({
                key: 'search',
                value
            }))


        }} />

        {children}

        <div className="pagination-container">{paginationItems}</div>
       
    </div>
}